/**
 * DiameterEdit domain object.
 *
 * Tracks a manually edited diameter at a specific centerline node.
 * Immutable after construction.
 */

import type { Vec3 } from '../types';

export class DiameterEdit {
    constructor(
        /** Centerline node ID */
        readonly nodeId: number,
        /** User-edited diameter value in mm */
        readonly editedValue: number,
        /** Original computed diameter from the node (for restore) */
        readonly originalValue: number,
        /** Edited first endpoint of the diameter line */
        readonly p1: Vec3,
        /** Edited second endpoint of the diameter line */
        readonly p2: Vec3
    ) {
        Object.freeze(this);
    }

    /** Whether the value actually differs from the original. */
    get isModified(): boolean {
        return Math.abs(this.editedValue - this.originalValue) > 1e-6;
    }

    /** Create a copy with a new edited value and endpoints. */
    withEdit(editedValue: number, p1: Vec3, p2: Vec3): DiameterEdit {
        return new DiameterEdit(this.nodeId, editedValue, this.originalValue, p1, p2);
    }
}

/** Build the composite key used in DiameterEdit maps. */
export function diameterEditKey(nodeId: number): number {
    return nodeId;
}
